import { GlobalConfig } from "stores/wizard/config/staticConfigs/global";

export const globalConfig: GlobalConfig = {
  navigation: {
    defaultLob: "wizard-hotel-pwa",
    activeLob: "wizard-hotel-pwa",
  },
  useLastSearchForMultiLOB: false,
};
